import LargeComponent from './Header'
import SmallComponent from './SmallHeader'
import WithResponsive from '../../hoc/WithResponsive'

export default WithResponsive(LargeComponent, SmallComponent)
